export default "__VITE_ASSET__DKBk2Rza__"